import{a as e}from"../../../../_virtual/index36.js";var t,r;t=e,r=e.exports,Object.defineProperty(r,"__esModule",{value:!0}),r.default=function(e,t){for(var r=e<0?"-":"",a=Math.abs(e).toString();a.length<t;)a="0"+a;return r+a},t.exports=r.default;
//# sourceMappingURL=index.js.map
